// src/lib/contact-schema.ts
import { z } from "zod";

export const PROJECT_TYPES = [
  "Lyric visualizer / Music video",
  "Album or EP campaign",
  "Season or show campaign",
  "Brand motion",
  "Short-form social content",
  "Something else",
] as const;

export const REFERRAL_SOURCES = [
  "Instagram",
  "LinkedIn",
  "Someone referred me",
  "Lürzers Archive",
  "Search",
  "Other",
] as const;

export const contactSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters").max(100),
  email: z.string().email("Please enter a valid email address"),
  organization: z.string().max(100).optional(),
  projectType: z.enum(PROJECT_TYPES).optional(),
  message: z
    .string()
    .min(10, "Message must be at least 10 characters")
    .max(2000, "Message must be under 2000 characters"),
  referral: z.enum(REFERRAL_SOURCES).optional(),
  // honeypot — should always be empty
  website: z.string().default(""),
});

export type ContactFormData = z.infer<typeof contactSchema>;
